// x-media-fullscreen-ck5.js

/*
This script:
- Sets classes used for fullscreen group transitions.

(Temp. detection of viewport height for iOS removed Feb 2026. Replaced by proper height units in CSS).
*/

export default function xMediaFullscreenCK5() {

  // Only run on article page
  if (document.body.id === "vrtx-structured-article") {

    // Don't run if in iframe (preview mode)
    // Doing it like this due to problems detecting vrtx-preview-mode class
    if (window !== window.parent) {
      return;
    }

    // Fullscreen groups
    // Note: Requires fullscreen class on all contained images
    const fullscreenGroups = document.querySelectorAll(".fullscreen-group");

    // Detect scroll positions for group and figures, then add/remove classes accordingly
    window.addEventListener('scroll', function() {
      fullscreenGroups.forEach((group) => {

        // When group fully occupies viewport, add active class
        const groupArea = group.getBoundingClientRect();
        if (groupArea.top <= 0 && groupArea.bottom >= window.innerHeight) {
          group.classList.add('active');
        } else {
          group.classList.remove('active');
        }

        // When figure fully occupies viewport, add active class
        const figures = group.querySelectorAll("figure");
        figures.forEach((figure) => {
          const figureArea = figure.getBoundingClientRect();
          if (figureArea.top <= 0 && figureArea.bottom >= window.innerHeight) {
            figure.classList.add('active');
          } else {
            figure.classList.remove('active');
          }
        });
      });
    });
  }
}
